import { useEffect, useState, useCallback } from 'react';
import { api } from '../../lib/api';

interface Tag {
  id: number;
  tag: string;
}

interface TagSelectorProps {
  selectedTags: number[];
  onTagsChange: (tags: number[]) => void;
  showDeleteButton?: boolean;
  onDeleteTag?: (id: number) => void;
  // 親がタグ一覧を既に持っている場合は渡すと自前 fetch を省略する。
  tags?: Tag[];
}

export const TagSelector = ({
  selectedTags,
  onTagsChange,
  showDeleteButton = false,
  onDeleteTag,
  tags: tagsProp,
}: TagSelectorProps) => {
  const [fetchedTags, setFetchedTags] = useState<Tag[]>([]);

  const fetchTags = useCallback(async () => {
    try {
      const data = await api.getTags();
      setFetchedTags([...data].sort((a, b) => a.tag.localeCompare(b.tag)));
    } catch (error) {
      console.error('タグの取得に失敗しました:', error);
    }
  }, []);

  useEffect(() => {
    if (tagsProp === undefined) fetchTags();
  }, [fetchTags, tagsProp]);

  const tags = tagsProp ?? fetchedTags;

  const toggleTag = (tagId: number) => {
    const newSelectedTags = selectedTags.includes(tagId)
      ? selectedTags.filter(id => id !== tagId)
      : [...selectedTags, tagId];
    onTagsChange(newSelectedTags);
  };

  return (
    <div className="flex flex-wrap gap-2">
      {tags.map((tag) => (
        <div
          key={tag.id}
          className={`
            flex items-center
            px-3 py-1 rounded-full
            ${
              selectedTags.includes(tag.id)
                ? 'bg-blue-500 text-white'
                : 'bg-gray-200 text-gray-700'
            }
            ${showDeleteButton ? 'pr-1' : ''}
          `}
        >
          <button
            type="button"
            onClick={() => toggleTag(tag.id)}
            className="text-sm"
          >
            {tag.tag}
          </button>
          {showDeleteButton && onDeleteTag && (
            <button
              onClick={() => onDeleteTag(tag.id)}
              className="ml-1 hover:text-red-500 text-sm"
              title="タグを削除"
            >
              <span className="opacity-60 hover:opacity-100">×</span>
            </button>
          )}
        </div>
      ))}
    </div>
  );
};
